(function($) {
	'use strict';

	var SELECTORS = {
		container: '[data-payment-options]'
	};

  var STATES = {
    activeItem: 'payment-options__item--active',
    active: 'active'
  };

  function handleClick(evt) {
    var $this = $(evt.target);
    var itemToShow = $this.attr('data-payment-option');

    $('.payment-options__item').not('[data-payment-option="' + itemToShow + '"]').removeClass(STATES.activeItem);
    $('.payment-options__item[data-payment-option="' + itemToShow + '"]').addClass(STATES.activeItem);

    if (window.innerWidth <= 991) {
      $('html, body').animate({
        scrollTop: $('.payment-options__items').offset().top - 90
      }, 1000);
    }
  }

  function init() {
    $(SELECTORS.container + ' input[type="radio"]').click(handleClick);
  }

  if ($(SELECTORS.container).length > 0) {
    init();
  }

})($jq);
